import Vue from 'vue';
import App from './App.vue';
import router from './router/router';
import store from './store/index';
import ViewUI from 'view-design';
import 'view-design/dist/styles/iview.css';
import './assets/style/style.less';
import storage from './global/storage';
import { Component } from 'vue-property-decorator';
import { Route } from 'vue-router';
import moment from 'moment';
import './assets/iconfont/iconfont.css'
import './my-theme/index.less'
import 'image-preview-vue/lib/imagepreviewvue.css'
import { isOffline } from './global/utils';
import VCalendar from 'v-calendar';

Vue.use(ViewUI);
Vue.config.productionTip = false;
Vue.prototype.$storage = storage;
Vue.prototype.$moment = moment;
Vue.use(VCalendar);
Component.registerHooks([
  'beforeRouteEnter',
  'beforeRouteLeave',
  'beforeRouteUpdate',
]);

router.beforeEach((to: Route, from: Route, next: () => void) => {
  next();
  // store.dispatch('getRecentList');
});

Vue.prototype.$eventBus = new Vue()

new Vue({
  router,
  store,
  render: (h) => h(App),
  data() {
    return {
      offline: isOffline()
    }
  }
}).$mount('#app');
